/**
 * @author Harshitha.k
 * @description 
 */

import React, { useEffect, useRef, useState, Fragment } from 'react';
import { Input, Form, Select, Button, message } from 'antd';
import './reportConfig.css';

const { Option } = Select;
const { TextArea } = Input;

const WidgetCustomization = (props) => {
  const userRef = useRef();
  const [widgetProperties, setWidgetProperties] = useState(props.widgetProperties || []);
  const [inputFields, setInputFields] = useState([]);
  const [payloadFields, setPayloadFields] = useState([]);
  const [showWidget, setShowWidget] = useState('false');
  const [widgetPicker, setWidgetPicker] = useState('');

  useEffect(() => {
    const Data = props.tableProperties && props.widgetProperties;
    const widgetData = Data && Data.displayWidget;
    const DisplayWidget = (widgetData && widgetData === true) || widgetData === 'true' ? 'true' : 'false';
    
    if (userRef.current) {
      userRef.current.setFieldsValue({
        displayWidget: DisplayWidget
      });
    }
  }, [props.tableProperties, props.widgetProperties]);

  useEffect(() => {
    if (props.widgetProperties) {
      setWidgetProperties(props.widgetProperties);
    }
  }, [props.widgetProperties]);

  const handleFieldChange = (value, colName) => {
    const updatedProperties = { ...widgetProperties, [colName]: value };
    setWidgetProperties(updatedProperties);
    setShowWidget(value);
    setWidgetPicker(value);
    props.jsonSaveObject(updatedProperties, 'selectionWidget');
  };

  // const handleChange = (value, keyName, key) => {
  //   const updatedProperties = { ...widgetProperties };
  //   updatedProperties[keyName][key] = value;
  //   setWidgetProperties(updatedProperties);
  //   props.jsonSaveObject(updatedProperties, 'selectionWidget');
  // };

  const widgetSave = () => {
    userRef.current.validateFields().then(async () => {
      props.jsonSaveObject(widgetProperties, 'selectionWidget');
      message.success('Widget Validated Successfully');
    });
  };

  const handlePayloadChange = (key, event, objectkey) => {
    const updatedProperties = { ...widgetProperties };
    if (objectkey === 'key') {
      updatedProperties.payload[event.target.value] = updatedProperties.payload[key];
      delete updatedProperties.payload[key];
    } else if (objectkey === 'value') {
      if (typeof updatedProperties.payload[key] === 'object') {
        updatedProperties.payload[key] = { format: event.target.value };
      } else {
        updatedProperties.payload[key] = event.target.value;
      }
    }
    setWidgetProperties(updatedProperties);
    props.jsonSaveObject(updatedProperties, 'selectionWidget');
  };

  const addPayload = () => {
    setInputFields([{ month: '', year: '' }]);
  };

  const handleAddFields = () => {
    setInputFields([...inputFields, { month: '', year: '' }]);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };

  const handleMainPayloadRemoveFields = (index) => {
    const updatedProperties = { ...widgetProperties };
    delete updatedProperties.payload[index];
    setWidgetProperties(updatedProperties);
  };

  const handlePayloadRemoveFields = (index) => {
    const values = [...payloadFields];
    values.splice(index, 1);
    setPayloadFields(values);
  };

  const UpdatePayload = () => {
    const updatedProperties = { ...widgetProperties };
    payloadFields.forEach(item => {
      updatedProperties.payload[item.reportKey] = item.reportValue;
    });
    setPayloadFields([]);
    setWidgetProperties(updatedProperties);
    props.jsonSaveObject(updatedProperties, 'selectionWidget');
  };

  const handlePayloadInputChange = (index, event) => {
    const values = [...payloadFields];
    values[index][event.target.name] = event.target.value;
    setPayloadFields(values);
  };

  const handleAddPayloadFields = () => {
    setPayloadFields([...payloadFields, { month: '', year: '' }]);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (values[index]) {
      values[index][event.target.name] = event.target.value;
    }
    setInputFields(values);
    const updatedProperties = { ...widgetProperties };
    values.forEach(item => {
      if (updatedProperties.payload) {
        updatedProperties.payload[item.reportKey] = item.reportValue;
      }
    });
    setWidgetProperties(updatedProperties);
    props.jsonSaveObject(updatedProperties, 'selectionWidget');
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
    }
  };

  return (
    <div style={{ margin: '50px' }}>
      {widgetProperties ? (
        <div>
          <Form
            {...formItemLayout}
            layout="vertical"
            ref={userRef}
            name="user_form"
            initialValues={widgetProperties}
          >
            <Form.Item label="DisplayWidget :" name="displayWidget">
              <Select
                value={widgetProperties.displayWidget}
                onSelect={(value) => handleFieldChange(value, 'displayWidget')}
              >
                <Option value="true">TRUE</Option>
                <Option value="false">FALSE</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Widget :"
              name="widget"
              rules={[{ required: showWidget === 'true', message: 'Please Select Widget!' }]}
            >
              <Select onSelect={(value) => handleFieldChange(value, 'widget')}>
                <Option value="date-picker">Date Picker</Option>
                <Option value="dateRange-picker">DateRange Picker</Option>
                <Option value="month-picker">Month Picker</Option>
                <Option value="monthRange-picker">MonthRange Picker</Option>
                <Option value="year-picker">Year Picker</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Placeholder :"
              rules={[{ required: showWidget === 'true', message: 'Please Select Placeholder!' }]}
            >
              <Input
                value={widgetProperties.placeholder}
                onChange={(e) => handleFieldChange(e.target.value, 'placeholder')}
              />
            </Form.Item>
            <Form.Item
              label="Format :"
              name="format"
              rules={[{ required: true, message: 'Please Provide Format!' }]}
            >
              <Select
                value={widgetProperties.format}
                onSelect={(value) => handleFieldChange(value, 'format')}
              >
                {widgetPicker === 'date-picker' ? (
                  <>
                    <Option value="MM-DD-YY">MM-DD-YY</Option>
                    <Option value="DD-MM-YY">DD-MM-YY</Option>
                    <Option value="YY-MM-DD">YY-MM-DD</Option>
                  </>
                ) : widgetPicker === 'month-picker' ? (
                  <>
                    <Option value="YY-MM">YYYY-MM</Option>
                    <Option value="MM-YY">MM-YY</Option>
                  </>
                ) : widgetPicker === 'year-picker' ? (
                  <Option value="YYYYY-MMMM">YYYYY-MMMM</Option>
                ) : widgetPicker === 'dateRange-picker' ? (
                  <Option value="DD-MM-YY-DD-MM-YY">DD-MM-YY - DD-MM-YY</Option>
                ) : widgetPicker === 'monthRange-picker' ? (
                  <Option value="MM-YY">MM-YY - MM-YY</Option>
                ) : null}
              </Select>
            </Form.Item>

            <Form.Item label="Payload :">
              {widgetProperties.payload && Object.entries(widgetProperties.payload).length > 0 ? (
                Object.entries(widgetProperties.payload)
                  .filter((key) => !['startDate', 'endDate'].includes(key))
                  .map(([key, value], index) => (
                    <div key={index}>
                      <input
                        type="text"
                        className="form-control"
                        id="month"
                        name="month"
                        value={key}
                        onChange={(e) => handlePayloadChange(key, e, 'key')}
                      />
                      {key !== 'month' && key !== 'year' ? (
                        <TextArea
                          maxLength="100"
                          style={{ width: '27%', marginLeft: '30px', height: '10px' }}
                          value={typeof value === 'object' ? JSON.stringify(value) : value}
                          onChange={(e) => handleInputChange(index, e)}
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          id="year"
                          name="year"
                          value={typeof value === 'object' ? value.format : value}
                          onChange={(e) => handlePayloadChange(key, e, 'value')}
                        />
                      )}
                      <Button
                        className="btn-link"
                        type="Button"
                        onClick={() => handleMainPayloadRemoveFields(key )}
                      >
                        -
                      </Button>
                      {Object.keys(widgetProperties.payload).length - 1 === index ? (
                        <Button
                          className="btn-link"
                          type="Button"
                          onClick={() => handleAddPayloadFields()}
                        >
                          +
                        </Button>
                      ) : null}
                    </div>
                  ))
              ) : (
                <div>
                  <Button onClick={(e) => addPayload(e)}>Add Payload</Button>
                  {inputFields.length > 0 &&
                    inputFields.map((item, index) => (
                      <Fragment key={`${item}~${index}`}>
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            id="month"
                            name="month"
                            value={item.month}
                            onChange={(e) => handleInputChange(index, e)}
                          />
                          <input
                            type="text"
                            className="form-control"
                            id="year"
                            name="year"
                            value={item.year}
                            onChange={(e) => handleInputChange(index, e)}
                          />
                          <Button
                            className="btn-link"
                            type="Button"
                            onClick={() => handleRemoveFields(index)}
                          >
                            -
                          </Button>
                          {inputFields.length - 1 === index ? (
                            <Button
                              className="btn-link"
                              type="Button"
                              onClick={() => handleAddFields()}
                            >
                              +
                            </Button>
                          ) : null}
                        </div>
                      </Fragment>
                    ))}
                </div>
              )}
              {payloadFields && payloadFields.length > 0
                ? payloadFields.map((item, index) => (
                    <Fragment key={`${item}~${index}`}>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          id="month"
                          name="month"
                          value={item.month}
                          onChange={(e) => handlePayloadInputChange(index, e)}
                        />
                        <input
                          type="text"
                          className="form-control"
                          id="year"
                          name="year"
                          value={item.year}
                          onChange={(e) => handlePayloadInputChange(index, e)}
                        />
                        <Button
                          className="btn-link"
                          type="Button"
                          onClick={() => handlePayloadRemoveFields(index)}
                        >
                          -
                        </Button>
                        {payloadFields.length - 1 === index ? (
                          <Button
                            className="btn-link"
                            type="Button"
                            onClick={() => handleAddPayloadFields()}
                          >
                            +
                          </Button>
                        ) : null}
                      </div>
                    </Fragment>
                  ))
                : null}
            </Form.Item>
          </Form>
          <div>
            <Button
              type="primary"
              onClick={(e) => widgetSave(e)}
            >
              Validate Json
            </Button>{' '}
            {payloadFields.length > 0 ? (
              <Button type="primary" onClick={(e) => UpdatePayload(e)}>
                Update Payload
              </Button>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default WidgetCustomization;